import SoftBox from "components/SoftBox";
import FromNow from "./FromNow";

const PropTypes = require("prop-types");

function LiveTab({ dataUpdatedAt }) {
    return (<SoftBox p={2}>
        <FromNow epoch={dataUpdatedAt}></FromNow>
    </SoftBox>);
}

LiveTab.propTypes = {
    dataUpdatedAt: PropTypes.Number
}

export default LiveTab;